<template>
	<KRSubHeaderLayout class="kr-sub-header-skeleton">
		<template #end-date>
			<Skeleton />
			<div class="skeleton-value">
				<Skeleton />
			</div>
		</template>
		<template #last-updated>
			<Skeleton />
			<div class="skeleton-value">
				<Skeleton />
			</div>
		</template>
		<template #confidence-level>
			<Skeleton />
			<div class="skeleton-value">
				<Skeleton />
			</div>
		</template>
		<template #progress>
			<Skeleton />
			<div class="skeleton-value">
				<Skeleton />
			</div>
		</template>
		<template #current>
			<Skeleton />
			<div class="skeleton-value">
				<Skeleton />
			</div>
		</template>
		<template #target>
			<Skeleton />
			<div class="skeleton-value">
				<Skeleton />
			</div>
		</template>
	</KRSubHeaderLayout>
</template>

<script>
import Skeleton from "primevue/skeleton";
import KRSubHeaderLayout from "./KRSubHeaderLayout";

export default {
	name: "KRSubHeaderSkeleton",
	components: {
		KRSubHeaderLayout,
		Skeleton,
	},
};
</script>

<style lang="scss" scoped>
.skeleton-value {
	width: 50%;
}
</style>

<style lang="scss">
.kr-sub-header-skeleton {
	.key-result-sub-header-layout__stack {
		flex: 1;
	}
}
</style>
